var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 2.72727273
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.0132680152 17.6566877 0.0132680152 17.6566877 17.935314 0 17.935314"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-copy-9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#3B7FF5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-13",
    fill: "#4D94FF",
    mask: "url(#mask-2)",
    points: "32.9752066 -2.72727273 -2.72727273 32.9752066 32.9752066 32.9752066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(10.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 5.203674)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6204048,17.9342215 C12.0859527,17.9344282 11.5514589,17.9367837 11.0170068,17.9333537 C10.772336,17.931742 10.6768252,17.8453317 10.7014422,17.6306489 C10.7955368,16.8096886 10.5539483,16.0648901 10.1774867,15.3541433 C9.48167016,14.0405077 8.57079816,12.87746 7.55587649,11.7980125 C6.42490903,10.5951689 5.24928934,9.43377416 4.11315688,8.23564161 C2.70736166,6.75315248 1.50345946,5.1274726 0.678351385,3.25004149 C0.350665725,2.50454046 0.0927075089,1.7347404 0.009317819,0.919689576 C-0.0100509152,0.730504226 0.0027366147,0.534376295 0.0289364723,0.345273595 C0.0629254768,0.0997624187 0.251322863,-0.0293778648 0.494744116,0.0259561639 C0.633157672,0.0574457306 0.776402998,0.112945059 0.891282501,0.194148469 C1.77028981,0.815344227 2.76396835,1.10482509 3.82316736,1.19925246 C4.09141392,1.22313825 4.24648875,1.32413628 4.33608477,1.58749981 C4.78698057,2.91237581 5.5554403,4.05525699 6.47451798,5.09676821 C7.15950472,5.87297363 7.88860218,6.61099485 8.60328765,7.36112427 C8.82300823,7.59175848 8.91493683,7.5854771 9.1364485,7.3678189 C10.2222223,6.30097552 11.2955834,5.21983373 12.1208997,3.93462963 C12.4916131,3.35736223 12.8158415,2.7445141 13.0999996,2.12034295 C13.3707037,1.52563645 13.7672837,1.20433542 14.436359,1.15011717 C15.2544693,1.08379072 15.9835251,0.742529769 16.6569739,0.284856604 C16.737073,0.230473048 16.8158809,0.174064572 16.8974795,0.121953885 C17.0720063,0.010418005 17.2528645,-0.0293778648 17.4453855,0.0805463445 C17.6456541,0.194850992 17.6633567,0.386102587 17.6551094,0.583057016 C17.613956,1.56609352 17.3384201,2.49049 16.9386745,3.38381016 C16.0958638,5.26739868 14.8944191,6.90853407 13.4805848,8.40395789 C13.0251072,8.88576479 12.551677,9.35112438 12.0806211,9.81821962 C11.7352328,10.1607203 11.7222786,10.2116326 12.0139759,10.5921522 C13.1868465,12.121917 13.9867544,13.8223123 14.3609667,15.7090828 C14.4783454,16.3010205 14.5353686,16.9057277 14.5998061,17.5067155 C14.6354612,17.8394222 14.5392007,17.9296758 14.2029761,17.9327752 C13.6754801,17.9376102 13.1479424,17.9340149 12.6204048,17.9342215",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.53724584,23.1747294 C4.03133633,23.1747294 3.52542683,23.1766223 3.01951732,23.1741121 C2.63203341,23.172178 2.54901898,23.0907808 2.56741115,22.7145758 C2.66919225,20.636848 3.26398338,18.7069356 4.35061941,16.9256204 C4.45431463,16.7556245 4.5578434,16.585464 4.66532525,16.4178137 C4.80376586,16.2018518 4.92073507,16.1833749 5.08938544,16.3690906 C5.87126072,17.2303867 6.65201249,18.0927528 7.42502457,18.9617854 C7.67140475,19.2388158 7.65804754,19.3431754 7.47279428,19.6586823 C7.25412719,20.0311013 7.03587622,20.4052075 6.84508866,20.7919472 C6.58772312,21.3135807 6.45906115,21.8741845 6.41757474,22.4524422 C6.40987666,22.5599294 6.43438568,22.6698033 6.4462865,22.7783603 C6.47807749,23.0676949 6.39285766,23.1734125 6.09641916,23.1768281 C5.57673633,23.182795 5.05697028,23.1785153 4.53724584,23.1785153 L4.53724584,23.1747294 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50824858,7.09611946 C8.49672761,7.09611946 9.48516598,7.09553936 10.473645,7.0963515 C10.9684741,7.09673824 11.1346505,7.31075651 10.9851852,7.76373735 C10.8292145,8.23617089 10.509141,8.61605911 10.1753245,8.97904709 C9.81007799,9.37626098 9.4176708,9.751083 9.03136258,10.1303911 C8.87112253,10.287753 8.73743329,10.289764 8.57560751,10.1342585 C7.88780729,9.47329239 7.24363497,8.7760894 6.75954006,7.96352383 C6.65988302,7.79626163 6.638496,7.57574624 6.62377717,7.37696527 C6.61015616,7.19318955 6.74937512,7.10215251 6.93913414,7.09840119 C7.12877119,7.09457253 7.31853021,7.09755038 7.50824858,7.09755038 L7.50824858,7.09611946 Z",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92488864,4.57292541 C2.95280345,4.57502653 2.20919419,3.90303955 2.20761916,3.02118828 C2.20600674,2.12943076 2.97095062,1.41945683 3.93360098,1.41918375 C4.87916664,1.41891082 5.67148003,2.13555392 5.67673499,2.99583764 C5.68206234,3.87230678 4.90615366,4.57081442 3.92488864,4.57292541",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83847802,0.157687083 C9.70138122,0.160664017 10.4092397,0.870088861 10.4073475,1.73007135 C10.4054477,2.59194255 9.69217217,3.31242988 8.84180566,3.31142874 C7.99271603,3.31046407 7.24852442,2.5649609 7.25360582,1.72047359 C7.25877819,0.871206673 7.98536427,0.154766598 8.83847802,0.157687083",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6800899,4.57292541 C12.6970106,4.57062388 11.9822112,3.9068229 11.9842183,2.99799679 C11.9861911,2.12418539 12.7528577,1.41926158 13.7014444,1.41918375 C14.6624416,1.41902815 15.4554269,2.14200399 15.4533341,3.01620444 C15.4511047,3.90954626 14.692783,4.5752536 13.6800899,4.57292541",
    id: "Fill-12",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(1.000000, 22.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C8.51283584,0 8.93550716,0.38604019 8.99327227,0.883378875 L9,1 L9,8 C9,8.55228475 8.55228475,9 8,9 C7.48716416,9 7.06449284,8.61395981 7.00672773,8.11662113 L7,8 L7,2 L1,2 C0.487164161,2 0.0644928393,1.61395981 0.00672773133,1.11662113 L0,1 C0,0.487164161 0.38604019,0.0644928393 0.883378875,0.00672773133 L1,0 L8,0 Z",
    id: "Path-3-Copy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.70710678,23.2928932 C9.06759074,23.6533772 9.09532028,24.2206082 8.79029539,24.6128994 L8.70710678,24.7071068 L2.64035842,30.7748087 C2.00832526,30.4998705 1.50075145,29.9924688 1.22558918,29.3605557 L7.29289322,23.2928932 C7.68341751,22.9023689 8.31658249,22.9023689 8.70710678,23.2928932 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraLink);
export default __webpack_public_path__ + "static/media/jira-link.69ca0ddd18690e82484547c3eb799490.svg";
export { ForwardRef as ReactComponent };